<template>
    <b-form-select
        @input="change"
        :options="options"
    />
</template>
<script>
import vSelect from 'vue-select'
import { BFormSelect } from 'bootstrap-vue'
export default {
    components: {
        vSelect,
        BFormSelect
    },
    props: {
        yesLabel: {
            default() {
                return this.$t('Component(YesNoFilter):yes');
            }
        },
        noLabel: {
            default() {
                return this.$t('Component(YesNoFilter):no');
            }
        }
    },
    data() {
        return {
            options: [
                {value: null, text: '-'},
                {value: true, text: this.yesLabel},
                {value: false, text: this.noLabel},
            ]
        };
    },
    methods: {
        change(value) {
            this.$emit('change', value);
        }
    }
}
</script>
